import { API, getAPIInstance } from "api/axios.config";
import { createApplicationService } from "./base/applicationServiceBase";
import { getDocument } from "api/index";

//-------------------------------------------
//           API Functions
//-------------------------------------------

const USER_BASE = "/Users";

const fetchCurrentUserAPI = async () => {
  const response = (await getAPIInstance()).get(`${USER_BASE}/me`);
  return response;
};

const fetchCurrentUserWithPhotoAPI = async () => {
  const userResponse = await fetchCurrentUserAPI();
  const userData = userResponse.data.data;
  
  // If user has a profile photo, fetch it and add to the user object
  if (userData.userImageDocumentId) {
    try {
      const photoResponse = await getDocument(userData.userImageDocumentId);
      userData.imageInfo = photoResponse.data.data;
    } catch (error) {
      console.warn("Failed to fetch user profile photo:", error);
      // Continue without photo if fetch fails
    }
  }
  
  return { ...userResponse, data: { data: userData } };
};

const getAccessRightsAPI = () => API.get(`${USER_BASE}/me/TeamAccess`);

//-------------------------------------------
//            Current User Service
//-------------------------------------------

const currentUserBaseService = createApplicationService({
  name: "currentUser",
  apiFetchFn: fetchCurrentUserWithPhotoAPI,
});

const currentUserReducer = currentUserBaseService.reducer;
const getCurrentUser = currentUserBaseService.getData;
const useCurrentUser = currentUserBaseService.useData;
const resetCurrentUser = currentUserBaseService.resetData;

const getAccessRightsData = getAccessRightsAPI;

export {
  currentUserReducer,
  getCurrentUser,
  useCurrentUser,
  getAccessRightsData,
  resetCurrentUser,
};
